import React from "react";
import "./PageLoader.css";

export default function PageLoader() {
  return (
    <div className="page-loader" dir="rtl" aria-label="در حال بارگذاری">
      <div className="page-loader__spinner" />
    </div>
  );
}
